module.exports = __webpack_public_path__ + "static/media/view stock.2f4ee4d4.svg";